import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './ui/foundation/tokens.css'
import './styles.css'
import './operations.css'
import './accessibility.css'
import './ui/foundation/theme.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
